/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'
import { FormattedList, useIntl } from 'react-intl'
import SelectableRow from '../../../../client/js/components/selection/SelectableRow'
import {
  mapProspectingAndCityToCityName,
  mapProspectingAndEstateTypeToType
} from '../../lib/mapping.mjs'
import Budget from '../Budget'
import CustomerLink from '../customer/CustomerLink'
import EstateTypeLabel from '../labels/EstateTypeLabel'
import TransactionLabel from '../labels/TransactionLabel'
import ProspectingStatusBadge from './ProspectingStatusBadge'
import { Table } from '@mantine/core'
import AnchorLink from '../../../../client/js/components/AnchorLink'
import CheckboxIcon from '../../../../client/js/components/form/CheckboxIcon'
import Ref from '../Ref'

export type ProspectingListItemProps = {
  item: Prospecting,
  itemLink: string
}

function ProspectingListItem (props: ProspectingListItemProps) {
  const { item, itemLink } = props
  const intl = useIntl()
  const link = useMemo(() => (
    itemLink.replace(/{id}/g, String(item.id))
  ), [item.id, itemLink])
  return (
    <SelectableRow value={item.id}>
      <Table.Td>
        <ProspectingStatusBadge prospecting={item} />
      </Table.Td>
      <Table.Td>
        <AnchorLink to={link}>
          <Ref value={item.id} />
        </AnchorLink>
      </Table.Td>
      <Table.Td>
        <CustomerLink customer={item.Customer} />
      </Table.Td>
      <Table.Td>
        <FormattedList
          value={item.types.map((el) => (
            <EstateTypeLabel
              key={mapProspectingAndEstateTypeToType(el)}
              value={mapProspectingAndEstateTypeToType(el)}
            />
          ))}
        />
      </Table.Td>
      <Table.Td>
        <TransactionLabel value={item.transaction} />
      </Table.Td>
      <Table.Td ta="end">
        <Budget
          min={item.minPrice}
          max={item.maxPrice}
        />
      </Table.Td>
      <Table.Td>
        {item.cities
          ? <FormattedList
            value={item.cities?.map(mapProspectingAndCityToCityName) || []}
          />
          : null}
      </Table.Td>
      <Table.Td>
        {item.furnished !== null
          ? <CheckboxIcon
            checked={item.furnished}
            label={item.furnished
              ? intl.formatMessage({
                id: 'furnished',
                defaultMessage: 'Meublé'
              })
              : intl.formatMessage({
                id: 'not_furnished',
                defaultMessage: 'Non meublé'
              })
            }
          />
          : null}
      </Table.Td>
      <Table.Td>
        {item.equipped !== null
          ? <CheckboxIcon
            checked={item.equipped}
            label={item.equipped
              ? intl.formatMessage({
                id: 'equipped',
                defaultMessage: 'Équipé'
              })
              : intl.formatMessage({
                id: 'not_equipped',
                defaultMessage: 'Non équipé'
              })
            }
          />
          : null}
      </Table.Td>
    </SelectableRow>
  )
}

export default ProspectingListItem
